import { render, staticRenderFns } from "./cartShop.vue?vue&type=template&id=51c12d0e&scoped=true"
import script from "./cartShop.vue?vue&type=script&lang=js"
export * from "./cartShop.vue?vue&type=script&lang=js"
import style0 from "./cartShop.vue?vue&type=style&index=0&id=51c12d0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c12d0e",
  null
  
)

export default component.exports